import React, { useRef } from 'react';
import { Box, useTheme, Button } from '@mui/material';
import { Settings } from '@mui/icons-material';
import { useLocation } from 'react-router-dom';
import ImportExportMAIQ, { ImportExportMAIQRef } from 'app/components/ImportExportMAIQ';
import { ImportExportTypes } from 'app/components/ImportExportMAIQ/types';

interface DealerSettingsImportExportProps {
  selectedDealerId?: string;
}

const ContentImportExport: React.FC<DealerSettingsImportExportProps> = ({ selectedDealerId }) => {
  const theme = useTheme();
  const location = useLocation();
  const isInAIAvatarLayout = location.pathname.startsWith('/ai-avatar-layout');
  const importExportRef = useRef<ImportExportMAIQRef>(null);

  // Configure the import/export for dealer settings
  const importExportConfig = ImportExportTypes.OFFERS(selectedDealerId);

  const handleSuccess = (result: any) => {
    console.log('Import/Export successful:', result);
    // You can add additional success handling here
  };

  const handleError = (error: any) => {
    console.error('Import/Export error:', error);
    // You can add additional error handling here
  };

  const handleImportComplete = (result: any) => {
    console.log('Import completed:', result);
    // You can add specific import completion handling here
  };

  const handleExportComplete = (result: any) => {
    console.log('Export completed:', result);
    // You can add specific export completion handling here
  };

  // Custom trigger button with dealer-specific styling
  const customTriggerButton = (
    <Button
      variant="contained"
      startIcon={<Settings />}
      disabled={!selectedDealerId}
      sx={{
        backgroundColor: isInAIAvatarLayout
          ? (theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white)
          : theme.palette.primary.main,
        color: isInAIAvatarLayout
          ? (theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.common.black)
          : theme.palette.primary.contrastText,
        '&:hover': {
          backgroundColor: isInAIAvatarLayout
            ? (theme.palette.mode === 'light' ? theme.palette.grey[800] : theme.palette.grey[300])
            : theme.palette.primary.dark,
        },
        '&:disabled': {
          backgroundColor: theme.palette.action.disabledBackground,
          color: theme.palette.action.disabled,
        },
        textTransform: 'none',
        fontWeight: 600,
        px: 3,
        py: 1
      }}
    >
      Content Import/Export
    </Button>
  );

  return (
    <Box sx={{ p: 2 }}>
      <ImportExportMAIQ
        ref={importExportRef}
        type={importExportConfig}
        onSuccess={handleSuccess}
        onError={handleError}
        onImportComplete={handleImportComplete}
        onExportComplete={handleExportComplete}
        showImport={true}
        showExport={true}
        modalTitle="Offer Import/Export"
        triggerButton={customTriggerButton}
        disabled={!selectedDealerId}
      />
    </Box>
  );
};

export default ContentImportExport;
